<template>
  <HomePageUpdateBanner v-if="showBanner && !homepageBannerDismissed"> <!-- hide post-launch banner on March 29th 2024-->
    <!-- POST-LAUNCH BANNER CONTENT -->
    <template v-slot:message>
      <span id="banner-msg">Explore Goalbook Toolkit's new homepage!</span>
      <a
        href="https://medium.com/innovative-instruction/toolkit-design-updates/home"
        target="_blank"
        aria-label="Learn more about Goalbook Toolkit's new homepage.">
        Learn More
        <OpensInNewTabIcon :external-link="true" />
      </a>
      <button
        @click="dismissBanner"
        aria-description="Dismiss new homepage banner."
        class="dismiss-btn">
        Dismiss
      </button>
    </template>
  </HomePageUpdateBanner>
</template>

  <script>
  import HomePageUpdateBanner from '@/components/home/HomePageUpdateBanner.vue'
  import { mapState } from 'vuex'
import OpensInNewTabIcon from '../OpensInNewTabIcon.vue';

  export default {
    name: 'HomePageUpdateWrapper',
    components: {
        HomePageUpdateBanner,
        OpensInNewTabIcon
    },
    props: {
      currentDate: {
        type: Date,
        default: () => (new Date()),
      },
    },
    computed: {
        ...mapState('user', {
            homepageBannerDismissed: state => state.browserStorage.homepageBannerDismissed
        }),
        showBanner() {
            return this.currentDate < new Date('2024-03-29T00:00:00-05:00')
        }
    },
    methods: {
        dismissBanner() {
            const val = {homepageBannerDismissed: true}
            this.$store.dispatch('user/setStorage', val)
        }
    }
  }
  </script>

  <style scoped lang="less">
  .dismiss-btn {
    display: 'inline-block';
    color: #245682;
    background: none;
    border: none;
    &:hover {
        text-decoration: underline;
    }
  }
  </style>
